var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import calcLinksToDisplay from './calcLinksToDisplay';
import PaginationItemWrapper from './PaginationItemWrapper';
var ELLIPSIS_MARK = -1;
export var defaultProps = {
    atBeginEnd: 2,
    aroundCurrent: 1,
    firstPageValue: 0,
    name: 'page',
    showFirstLast: true,
    showPrevNext: true,
};
var PaginationWrapper = function (_a) {
    var _b = _a.atBeginEnd, atBeginEnd = _b === void 0 ? defaultProps.atBeginEnd : _b, _c = _a.aroundCurrent, aroundCurrent = _c === void 0 ? defaultProps.aroundCurrent : _c, disabled = _a.disabled, _d = _a.firstPageValue, firstPageValue = _d === void 0 ? defaultProps.firstPageValue : _d, _e = _a.name, name = _e === void 0 ? defaultProps.name : _e, onChange = _a.onChange, readOnly = _a.readOnly, _f = _a.showFirstLast, showFirstLast = _f === void 0 ? defaultProps.showFirstLast : _f, _g = _a.showPrevNext, showPrevNext = _g === void 0 ? defaultProps.showPrevNext : _g, totalPages = _a.totalPages, value = _a.value, etc = __rest(_a, ["atBeginEnd", "aroundCurrent", "disabled", "firstPageValue", "name", "onChange", "readOnly", "showFirstLast", "showPrevNext", "totalPages", "value"]);
    var zeroBasedValue = value - firstPageValue;
    var handleClickF = useCallback(function (page) {
        if (!onChange) {
            console.warn("onChange() method is not set for PaginationWrapper (\"" + name + "\"), but page change occurs");
            return;
        }
        var toReport = page + firstPageValue;
        return onChange({ target: { name: name, value: toReport } });
    }, [firstPageValue, name, onChange]);
    var handleFirst = useCallback(function () { return handleClickF(0); }, [handleClickF]);
    var handlePrev = useCallback(function () { return handleClickF(zeroBasedValue - 1); }, [handleClickF, zeroBasedValue]);
    var handlePage = useCallback(function (page) { return handleClickF(page); }, [handleClickF]);
    var handleNext = useCallback(function () { return handleClickF(zeroBasedValue + 1); }, [handleClickF, zeroBasedValue]);
    var handleLast = useCallback(function () { return totalPages !== undefined ? handleClickF(totalPages - 1) : undefined; }, [handleClickF, totalPages]);
    var linksToDisplay = calcLinksToDisplay(totalPages, zeroBasedValue, atBeginEnd, aroundCurrent, ELLIPSIS_MARK);
    var allDisabled = disabled || readOnly;
    return React.createElement(Pagination, __assign({}, etc),
        showFirstLast && (zeroBasedValue <= 0 || allDisabled
            ? React.createElement(Pagination.First, { disabled: true, key: "-2" })
            : React.createElement(Pagination.First, { key: "-2", onClick: handleFirst })),
        showPrevNext && (zeroBasedValue <= 0 || allDisabled
            ? React.createElement(Pagination.Prev, { disabled: true, key: "-1" })
            : React.createElement(Pagination.Prev, { key: "-1", onClick: handlePrev })),
        linksToDisplay.map(function (p, index) {
            return p === zeroBasedValue
                ? React.createElement(Pagination.Item, { active: true, key: p }, p + 1)
                : p === ELLIPSIS_MARK
                    ? React.createElement(Pagination.Ellipsis, { disabled: true, key: "_" + index })
                    : allDisabled
                        ? React.createElement(Pagination.Item, { disabled: true, key: p }, p + 1)
                        : React.createElement(PaginationItemWrapper, { key: p, onClick: handlePage, page: p });
        }),
        showPrevNext && (totalPages !== undefined && zeroBasedValue >= totalPages - 1 || allDisabled
            ? React.createElement(Pagination.Next, { disabled: true, key: "+1" })
            : React.createElement(Pagination.Next, { key: "+1", onClick: handleNext })),
        totalPages !== undefined && showFirstLast && (zeroBasedValue >= totalPages - 1 || allDisabled
            ? React.createElement(Pagination.Last, { disabled: true, key: "+2" })
            : React.createElement(Pagination.Last, { key: "+2", onClick: handleLast })));
};
export default React.memo(PaginationWrapper);
